import { Navigate, Route, Routes } from 'react-router-dom';
import { ChildPicker } from './screens/ChildPicker.js';
import { ChildPin } from './screens/ChildPin.js';
import { ChildHome } from './screens/ChildHome.js';
import { ParentLogin } from './screens/ParentLogin.js';
import { AdminHome } from './screens/AdminHome.js';
import { AdminChildren } from './screens/AdminChildren.js';
import { AdminPhonics } from './screens/AdminPhonics.js';
import { AdminCurriculum } from './screens/AdminCurriculum.js';
import { AdminAudio } from './screens/AdminAudio.js';
import { AdminWriting } from './screens/AdminWriting.js';
import { AdminSiblings } from './screens/AdminSiblings.js';
import { AdminDashboard } from './screens/AdminDashboard.js';
import { CharacterBuilder } from './screens/CharacterBuilder.js';
import { ArtGallery } from './screens/ArtGallery.js';
import { Activity } from './screens/Activity.js';
import { Collection } from './screens/Collection.js';
import { CheckIn } from './screens/CheckIn.js';
import { AdminCheckIns } from './screens/AdminCheckIns.js';
import { Quest } from './screens/Quest.js';
import { AdminQuests } from './screens/AdminQuests.js';
import { AdminProgress } from './screens/AdminProgress.js';
import { Games } from './screens/Games.js';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<ChildPicker />} />
      <Route path="/pin/:childId" element={<ChildPin />} />
      <Route path="/home" element={<ChildHome />} />
      <Route path="/character" element={<CharacterBuilder />} />
      <Route path="/checkin" element={<CheckIn />} />
      <Route path="/quest" element={<Quest />} />
      <Route path="/play" element={<Activity />} />
      <Route path="/games" element={<Games />} />
      <Route path="/shelf" element={<Collection />} />
      <Route path="/parent" element={<ParentLogin />} />
      <Route path="/admin" element={<AdminHome />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/children" element={<AdminChildren />} />
      <Route path="/admin/children/:childId/phonics" element={<AdminPhonics />} />
      <Route path="/admin/curriculum" element={<AdminCurriculum />} />
      <Route path="/admin/progress" element={<AdminProgress />} />
      <Route path="/admin/audio" element={<AdminAudio />} />
      <Route path="/admin/writing" element={<AdminWriting />} />
      <Route path="/admin/checkins" element={<AdminCheckIns />} />
      <Route path="/admin/quests" element={<AdminQuests />} />
      <Route path="/admin/siblings" element={<AdminSiblings />} />
      {import.meta.env.DEV && <Route path="/art" element={<ArtGallery />} />}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
